'use-strict'
class imageDraggable {
  constructor(index) {
    this.width = 100
    this.height = 100
    this.minWidth = 10
    this.minHeight = 10
    this.type = ''
    this.draggable = true
    this.resizable = true
    this.backgroundColor = 'white'
    this.lockAspectRatio = false
    this.x = 0
    this.y = 0
    this.index = index || 0
  }
}
module.exports = imageDraggable
